import { Spinner } from '@/components/ui';
import { FirestoreCollection } from '@shared/types';

interface CollectionListProps {
  collections: FirestoreCollection[];
  loading: boolean;
  selectedCollection: string | null;
  onSelectCollection: (collectionId: string) => void;
}

export function CollectionList({
  collections,
  loading,
  selectedCollection,
  onSelectCollection,
}: CollectionListProps) {
  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <Spinner size="sm" />
      </div>
    );
  }

  if (collections.length === 0) {
    return (
      <div className="p-4 text-sm text-muted-foreground text-center">No collections found</div>
    );
  }

  return (
    <div className="space-y-1">
      {collections.map((collection) => (
        <button
          key={collection.id}
          onClick={() => onSelectCollection(collection.id)}
          className={`
            w-full cursor-pointer text-left px-3 py-2 text-sm rounded-md transition-colors
            ${
              selectedCollection === collection.id
                ? 'bg-primary text-primary-foreground'
                : 'hover:bg-accent hover:text-accent-foreground'
            }
          `}
        >
          {collection.id}
        </button>
      ))}
    </div>
  );
}
